import ReactDOM from 'react-dom/client';
import {
  RouterProvider,
  createBrowserRouter,
  matchRoutes,
} from 'react-router-dom';
// import "./hydration-debugger";
import { isRouteSSR, routes } from './router';
import { SSRContext } from './ssr-context';
import tracking from './service/tracking';
import { env } from './utils/env';
import { faro } from './service/faro';
import { HelmetProvider } from 'react-helmet-async';

if (!window.__SS_BOT__ && window.configuration.PUBLIC_FARO_ENABLED) {
  faro.unpause();

  tracking.initiate();
}

const appRoot = document.getElementById('app-root')!;

const origWarn = console.warn;
console.warn = (...params: string[]) => {
  if (params[0]?.includes(' has been externalized for')) {
    // surpass the warning for sanitize-html
    // see https://github.com/apostrophecms/sanitize-html/issues/639
    return;
  }
  origWarn(...params);
};

if (!env.isSSR() && typeof __SS_BOT__ === 'undefined') {
  window.__SS_BOT__ = false;
}

async function hydrateApp() {
  // Source: https://reactrouter.com/en/main/guides/ssr#lazy-routes
  //        & https://github.com/remix-run/react-router/issues/10918
  //        Fixes double render for lazy routes.
  // Determine if any of the initial routes are lazy
  let lazyMatches = matchRoutes(routes, window.location)?.filter(
    (m) => m.route.lazy,
  );

  // Load the lazy matches and update the routes before creating your router
  // so we can hydrate the SSR-rendered content synchronously
  if (lazyMatches && lazyMatches?.length > 0) {
    await Promise.all(
      lazyMatches.map(async (m) => {
        let routeModule = { ...(await m.route.lazy!()) };
        Object.assign(m.route, {
          ...routeModule,
          lazy: undefined,
        });
      }),
    );
  }

  let router = createBrowserRouter(routes);
  const ssr = isRouteSSR(window.location.pathname);
  ReactDOM.hydrateRoot(
    appRoot,
    <HelmetProvider>
      <SSRContext.Provider
        value={{ isSSR: false, isUAMobile: false, isRouteSSR: ssr }}
      >
        <RouterProvider router={router} />
      </SSRContext.Provider>
    </HelmetProvider>,
  );
}

if (document.readyState === 'complete') {
  hydrateApp();
} else {
  window.addEventListener('DOMContentLoaded', hydrateApp);
}
